import { DeleteIcon, EditIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { type Volume } from '@generated/graphql';
import { type MouseEvent } from 'react';
import { useDeleteVolumeModal } from './DeleteVolumeModal';
import { useEditVolumeModal } from './EditVolumeModal';

type VolumeControlsProps = {
  volume: Volume;
  onChange: VoidFunction;
};

export const VolumeControls = ({ volume, onChange }: VolumeControlsProps) => {
  const { showModal: showEditVolumeModal } = useEditVolumeModal({
    componentProps: { volumeId: volume.volumeId, onEdit: onChange },
  });
  const handleEditVolume = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    showEditVolumeModal();
  };

  const { showModal: showDeleteVolumeModal } = useDeleteVolumeModal({ volume, onDelete: onChange });
  const handleDeleteVolume = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    showDeleteVolumeModal();
  };

  return (
    <Group alignItems="center" justifyContent="flex-end" flex={1} flexShrink={0} gap={1}>
      <IconButton
        Icon={EditIcon}
        tooltip="Details"
        onClick={handleEditVolume}
        size={16}
        variant="default"
      />
      <IconButton
        Icon={DeleteIcon}
        tooltip="Delete"
        onClick={handleDeleteVolume}
        size={16}
        variant="error"
      />
    </Group>
  );
};
